var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('SwitchComponent',{attrs:{"setValue":_vm.setValue},on:{"update:setValue":function($event){_vm.setValue=$event},"update:set-value":function($event){_vm.setValue=$event},"onChange":_vm.onChange}}),_c('span',{staticClass:"ml-4 text-color-primary font-bold"},[_vm._v("Borrador / Publicar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }